import { request } from './utils';

export default class MailSoarService {
    static async sendTestEmails() {
        const response = await request(`/admin/mail-soar/send-test-emails`, { method: 'POST' });

        return response;
    }
}
